import React from 'react';
import { AppContext } from '../../context/AppContext/context';
import { Appointment } from '../../interfaces';

function useCalendarSelectedAppointment() {
  const { state, dispatch } = React.useContext(AppContext);
  const {
    selectedAppointment,
    selectedAppointmentUpdated,
    openedAppointment,
    openedAppointmentIntent,
  } = state;

  // Set selectedAppointmentUpdated
  const setSelectedAppointmentUpdated = React.useCallback(
    (updated: boolean) => {
      dispatch({
        type: 'SET_SELECTED_APPOINTMENT_UPDATED',
        payload: updated,
      });
    },
    [dispatch],
  );

  // Set selectedAppointment to an appointment or null when none is selected
  const setSelectedAppointment = React.useCallback(
    (appointment: Appointment | null) => {
      dispatch({ type: 'SET_SELECTED_APPOINTMENT', payload: appointment });
    },
    [dispatch],
  );

  // Set openedAppointment to an appointment or null when none is selected
  const setOpenedAppointment = React.useCallback(
    (appointment: Appointment | null) => {
      dispatch({ type: 'SET_OPENED_APPOINTMENT', payload: appointment });
    },
    [dispatch],
  );

  const setOpenedAppointmentIntent = React.useCallback(
    (intent: 'waiver' | null) => {
      dispatch({ type: 'SET_OPENED_APPOINTMENT_INTENT', payload: intent });
    },
    [dispatch],
  );

  return {
    selectedAppointment,
    selectedAppointmentUpdated,
    setSelectedAppointmentUpdated,
    setSelectedAppointment,
    openedAppointment,
    setOpenedAppointment,
    openedAppointmentIntent,
    setOpenedAppointmentIntent,
  };
}

export default useCalendarSelectedAppointment;
